
import { Component, Mixins } from "vue-property-decorator";
import FormLogin from "./";
const Words: Dictionary = {
  error: "所属先IDまたは所属先パスワードに誤りがあります。",
  error2: "システムエラー",
  account: "所属先ID",
  password: "所属先パスワード",
  login: "所属先IDでログイン",
};
@Component
export default class FormLoginJa extends Mixins(FormLogin) {
  private words = Words;
}
